import { Controller } from "../../ts/controller";
import { Logger } from "../../ts/utils/logger";

export class SideNavController extends Controller {
    visible: boolean = true;
    prevScreenWidth: number | null = null;

    constructor() {
        super({
            logLabel: "SideNavController",
        });
    }

    public initialize(): void {
        this._handleScreenSize();
        window.addEventListener("resize", this._handleScreenSize.bind(this));

        const anchors = document.querySelectorAll('#side-nav a');
        for (const anchor of anchors) {
            anchor.addEventListener('click', event => {
                this.visible = false;
                this._setState();
            });
        }
        this.bindClick({
            elementId: "side-nav-toggle-button-inside-side-nav",
            handler: this.toggleVisible.bind(this),
        });
        this._setState();
        Logger.info(this.logLabel, "Initialized");
    }

    private _setState(): void {
        this._setSideNavVisibilityState();
    }

    private _setSideNavVisibilityState(): void {
        const sideNav = this.getElementByIdOrWarn("side-nav");
        if (sideNav) {
            sideNav.style.display = this.visible ? "block" : "none";
        }
    }

    public toggleVisible(): void {
        this.visible = !this.visible;
        this._setState();
    }

    private _handleScreenSize(): void {
        const screenWidth = window.innerWidth;

        if (
            this.prevScreenWidth === null ||
            this.prevScreenWidth >= 650
        ) {
            this.visible = false;
        }

        this.prevScreenWidth = screenWidth;
        this._setState();
    }
}
